export default __webpack_public_path__ + "static/lgbtq-pr-sj-2-09a918f7a8880f0a4c50d9b8dcabd3e0.jpg";